/**
 * Utility for transliterating Bulgarian Cyrillic text to Latin characters.
 * Follows the official Bulgarian transliteration system (Streamlined System).
 */

const cyrillicToLatinMap: Record<string, string> = {
  // Uppercase letters
  А: "A",
  Б: "B",
  В: "V",
  Г: "G",
  Д: "D",
  Е: "E",
  Ж: "Zh",
  З: "Z",
  И: "I",
  Й: "Y",
  К: "K",
  Л: "L",
  М: "M",
  Н: "N",
  О: "O",
  П: "P",
  Р: "R",
  С: "S",
  Т: "T",
  У: "U",
  Ф: "F",
  Х: "H",
  Ц: "Ts",
  Ч: "Ch",
  Ш: "Sh",
  Щ: "Sht",
  Ъ: "A",
  Ь: "Y",
  Ю: "Yu",
  Я: "Ya",

  // Lowercase letters
  а: "a",
  б: "b",
  в: "v",
  г: "g",
  д: "d",
  е: "e",
  ж: "zh",
  з: "z",
  и: "i",
  й: "y",
  к: "k",
  л: "l",
  м: "m",
  н: "n",
  о: "o",
  п: "p",
  р: "r",
  с: "s",
  т: "t",
  у: "u",
  ф: "f",
  х: "h",
  ц: "ts",
  ч: "ch",
  ш: "sh",
  щ: "sht",
  ъ: "a",
  ь: "y",
  ю: "yu",
  я: "ya",
};

/**
 * Transliterates Bulgarian Cyrillic text to Latin characters.
 * Non-Cyrillic characters (including spaces, numbers, punctuation) are preserved.
 */
export function toLatinTransliteration(cyrillicText: string | null | undefined): string {
  if (!cyrillicText) {
    return "";
  }

  let result = "";

  for (const char of cyrillicText) {
    const latinEquivalent = cyrillicToLatinMap[char];
    if (latinEquivalent) {
      result += latinEquivalent;
    } else {
      // Keep non-Cyrillic characters as-is (spaces, numbers, Latin letters, etc.)
      result += char;
    }
  }

  return result;
}

/**
 * Checks if a string contains any Cyrillic characters.
 */
export function containsCyrillic(text: string | null | undefined): boolean {
  if (!text) {
    return false;
  }

  for (const char of text) {
    if (cyrillicToLatinMap[char]) {
      return true;
    }
  }

  return false;
}
